var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.03 3.665h7.494c.263 0 .476.218.476.488s-.213.488-.476.488H2.475A.481.481 0 0 1 2 4.153c0-.27.213-.488.475-.488h2.13c.283 0 .53-.207.585-.491l.159-.813c.16-.618.68-1.027 1.272-1.027H9.38c.592 0 1.112.41 1.265.996a.49.49 0 0 1-.336.598.475.475 0 0 1-.583-.345.361.361 0 0 0-.346-.273H6.62a.361.361 0 0 0-.346.273l-.152.782c-.02.105-.053.204-.092.3Zm-.594 10c-.61-.013-.957-.353-1.028-1.011-.204-1.882-.554-6.339-.557-6.383a.487.487 0 0 0-.512-.448.484.484 0 0 0-.436.525c.003.045.354 4.517.56 6.414.122 1.136.87 1.855 1.954 1.878h.01c.258 0 .47-.21.476-.477a.483.483 0 0 0-.467-.498Zm7.225-7.842a.487.487 0 0 0-.512.447c-.004.045-.356 4.513-.558 6.38-.072.673-.423 1.005-1.072 1.018l-.259.005c-.825.014-1.208.021-2.13.018H8.13a.48.48 0 0 0-.476.486.482.482 0 0 0 .474.49h.487c.68 0 .95-.005 1.46-.015l.462-.01c1.128-.02 1.876-.725 2-1.885.204-1.88.557-6.364.56-6.408a.484.484 0 0 0-.435-.526Z",
    fill: "#991B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.30452911dcb54eea64f2d308a54cb41c.svg";
export { ForwardRef as ReactComponent };